import SelectedService from '../model/selected-service'

export default function validateSelectedService(service: unknown): SelectedService | null {
  if (typeof service !== 'object' || service === null) return null
  if (!('id' in service && 'planId' in service)) return null
  if (typeof service.id !== 'string') return null
  if (typeof service.planId !== 'string') return null
  return service as SelectedService
}
